import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const GyoshuKbn = props => {
  return <Dropdown.Static kubunKey='gyoshu_kbn' {...props} />
}
